<template>
    <header>
        <TheMessage
            v-if="messages"
            :text="message.text"
            :type="message.type"
        />

<!--        <div class="container">-->
<!--            <div class="col-md-12 mt-3">-->
<!--                <a href="https://familyoptic.pl">-->
<!--                    <img width="320" class="mx-auto" src="../assets/fo-ts.png" alt="Family Optic">-->
<!--                </a>-->
<!--            </div>-->
<!--            <div class="col-12">-->
<!--              <img class="banner bannerDesktop" src="../assets/desktop.jpg" alt="">-->
<!--              <img class="banner bannerMobile" src="../assets/mobile.png" alt="">-->
<!--            </div>-->
<!--        </div>-->
    </header>
</template>

<script>
    import TheMessage from "@/components/ui/TheMessage";
    export default {
        name: "TheHeader",
        components: {TheMessage},
        data() {
            return {
                message: null
            }
        },
        computed: {
            messages() {
                return this.$store.state.showMessage;
            }
        },
        watch: {
            messages(val) {
                if(val === true) {
                    this.message = {
                        text: this.$store.state.message.text,
                        type: this.$store.state.message.type
                    };
                }

            }
        }
    }
</script>

<style scoped>
.banner{
  width: 100%;
  margin: 0 auto;
}
.bannerDesktop{
  display: none;
}
.bannerMobile{
  display: block;
}

@media only screen and (min-width: 768px) {
  .bannerDesktop{
    display: block;
  }
  .bannerMobile{
    display: none;
  }
}
</style>